import React from 'react';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import axios from 'axios';
import { user_token } from '../../../services/Auth';

var token = localStorage.getItem(user_token);

export default class Forms_Prontuario_Inicial extends React.Component {
    constructor() {
        super();
        this.state = {
            name: "",
            birth: "",
            first: true,
            antecedents: "",
            medications_in_use: "",
            physical_activity: "",
            smoking: "",
            smoking_amount: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSubmit = evt => {
        evt.preventDefault();

        const agent = {
            name: this.state.name,
            birth: this.state.birth,
            antecedents: this.state.antecedents,
            medications_in_use: this.state.medications_in_use,
            physical_activity: this.state.physical_activity,
            smoking: this.state.smoking,
            smoking_amount: this.state.smoking_amount,
        };

        axios.post(`http://api-convida.herokuapp.com/user`, agent, {headers: {'x-access-token': token}} )
            .then(res => {
                console.log(res);
                console.log(res.data);
            })
    }
    render() {
        return (
            <>
            <form onSubmit={this.handleSubmit} id="forms-Pront_Init">
                <h1 id="tittle-forms-cme">Prontuário Inicial</h1>
                <br></br>
                <p id="RI-Title-Cadastro" >Nome do Paciente:</p>
                <input onChange={this.handleChange} name="name" placeholder="Nome do Paciente" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Idade do Paciente:</p>
                <input onChange={this.handleChange} name="birth" placeholder="Idade do Paciente" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >CPF do Profissional de Saúde:</p>
                <input onChange={this.handleChange} name="professional_cpf" placeholder="CPF" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Nome do Profissional de Saúde:</p>
                <input onChange={this.handleChange} name="professional_name" placeholder="Nome do Profissional" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Data da Consulta:</p>
                <input onChange={this.handleChange} name="date" placeholder="Data" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Antecedentes:</p>
                <input onChange={this.handleChange} name="antecedents" placeholder="Antecedentes" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Medicamentos em uso</p>
                <input onChange={this.handleChange} name="medications_in_use" placeholder="Medicamentos em uso" id="RI-Cadastro" />
                <p type="ratio" id="RI-Title-Cadastro">Pratica atividade física regularmente?</p>
                <select id="Pront_Init" onChange={this.handleChange} name="physical_activity">
                    <option value="Y">Sim</option>
                    <option value="N">Não</option>
                </select>
                <p type="ratio" id="RI-Title-Cadastro">Tabagismo</p>
                <select id="Pront_Init" onChange={this.handleChange} name="smoking">
                    <option value="Y">Sim</option>
                    <option value="N">Não</option>
                </select>
                <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quantos cigarros o paciente fuma por dia?</p>
                <input onChange={this.handleChange} name="smoking_amount" placeholder="Quantidade de cigarros por dia" id="RI-Cadastro" />
                <p type="ratio" id="RI-Title-Cadastro">Alcoolismo</p>
                <select id="Pront_Init" onChange={this.handleChange} name="physical_activity">
                    <option value="Y">Sim</option>
                    <option value="N">Não</option>
                </select>
                <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quanto o paciente beb por dia?</p>
                <input onChange={this.handleChange} name="smoking_amount" placeholder="Quantidade consumida por dia" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Histórico de Cirurgias:</p>
                <input onChange={this.handleChange} name="name" placeholder="Cirurgia" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Histórico Familiar:</p>
                <input onChange={this.handleChange} name="name" placeholder="Histórico Familiar" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Queixas Atuais:</p>
                <input onChange={this.handleChange} name="name" placeholder="Queixas Atuais" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Exames Físicos:</p>
                <input onChange={this.handleChange} name="name" placeholder="Exames Físicos" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Exames Complementares:</p>
                <input onChange={this.handleChange} name="name" placeholder="Exames Complementares" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Diagnóstico:</p>
                <input onChange={this.handleChange} name="name" placeholder="Diagnóstico" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Orientação:</p>
                <input onChange={this.handleChange} name="name" placeholder="Orientação" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Medicamentos Prescritos:</p>
                <input onChange={this.handleChange} name="name" placeholder="Medicamentos Prescritos" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Exames Requeridos:</p>
                <input onChange={this.handleChange} name="name" placeholder="Exames Requeridos" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Referência Médica:</p>
                <input onChange={this.handleChange} name="name" placeholder="Referência Médica" id="RI-Cadastro"/>
                <p id="RI-Title-Cadastro" >Observações:</p>
                <input onChange={this.handleChange} name="name" placeholder="Observações" id="RI-Cadastro"/>
                <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
            </form>
            </>
        );
    }
}
